
import {defineComponent, PropType} from "vue";
import {AppItem, AppsHelper} from "@/helpers/AppsHelper";
import {AppEnum} from "@/models/enum/AppEnum";

export default defineComponent({
  name: "AppDrawer",
  props: {
    currentApp: {
      type: String as PropType<AppEnum>,
      required: true,
    },
  },
  computed: {
    authorizedApps(): AppItem[] {
      return AppsHelper.getAuthorizedApps(this.currentApp);
    },
  },
  methods: {
    isCurrentApp(app: AppItem): boolean {
      return AppsHelper.isCurrentApp(app, this.currentApp);
    },
    appTitle(app: AppItem): string {
      const key = `apps.${app.code}`;

      return this.$te(key) ? this.$t(key) : app.code;
    },
    appDescription(app: AppItem): string {
      const key = `apps.descriptions.${app.code}`;

      return this.$te(key) ? this.$t(key) : '';
    },
  },
});
